import { assertExhaustive } from '@/libs/utilities/assertExhaustive'
import type { UserVariableDefinitionValue } from '@/types/schema.generated'

export type UserVariableDefinitionValueTypeName = NonNullable<
  UserVariableDefinitionValue['__typename']
>

export function stringifyUserVariableDataType(
  type: UserVariableDefinitionValueTypeName
): string {
  switch (type) {
    case 'UserVariableDefinitionValueString':
      return '文字列型'
    case 'UserVariableDefinitionValueText':
      return '長文型'
    case 'UserVariableDefinitionValueSelect':
      return '単体 選択型'
    case 'UserVariableDefinitionValueMultipleSelect':
      return '複数 選択型'
    default:
      assertExhaustive(type)
  }
}
